import React, { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Brand from './Brand';

const { FiArrowLeft, FiArrowRight, FiPlus, FiTrash2, FiUploadCloud, FiDatabase, FiDownload, FiShield, FiCheckCircle } = FiIcons;

const initialServices = [
  { name: 'زراعة الأسنان', value: 4000 },
  { name: 'تقويم الأسنان', value: 6000 },
  { name: 'ابتسامة / فينير', value: 3000 },
  { name: 'تبييض الأسنان', value: 700 }
];

export default function Onboarding({ navigate }) {
  const [step, setStep] = useState(1);
  const [services, setServices] = useState(initialServices);
  const [file, setFile] = useState('');

  const addService = () => setServices([...services, { name: 'خدمة جديدة', value: 1000 }]);
  const update = (index, key, value) => setServices(services.map((item, itemIndex) => itemIndex === index ? { ...item, [key]: value } : item));
  const remove = (index) => setServices(services.filter((_, itemIndex) => itemIndex !== index));

  return (
    <main className="onboarding-page">
      <header><Brand /><button className="text-button" onClick={() => navigate('/')}>حفظ والخروج</button></header>
      <section className="onboarding-shell">
        <div className="progress-copy"><span>الخطوة {step} من 3</span><b>{Math.round(step / 3 * 100)}%</b></div>
        <div className="progress-track"><span style={{ width: `${step / 3 * 100}%` }} /></div>
        {step === 1 && <ClinicStep />}
        {step === 2 && <ServicesStep services={services} add={addService} update={update} remove={remove} />}
        {step === 3 && <DataStep file={file} setFile={setFile} />}
        <div className="onboarding-actions">
          {step > 1 && <button className="btn secondary" onClick={() => setStep(step - 1)}><SafeIcon icon={FiArrowRight} /> السابق</button>}
          {step < 3 ? (
            <button className="btn primary" onClick={() => setStep(step + 1)}>التالي <SafeIcon icon={FiArrowLeft} /></button>
          ) : (
            <button className="btn primary" onClick={() => navigate('/analysis')}>ابدأ التحليل <SafeIcon icon={FiArrowLeft} /></button>
          )}
        </div>
      </section>
    </main>
  );
}

function ClinicStep() {
  return (
    <div className="onboarding-content">
      <h1>أخبرنا عن عيادتك</h1>
      <p>سنستخدم هذه المعلومات لتخصيص تحليلات الإيرادات.</p>
      <div className="form-grid">
        <label className="field wide"><span>اسم العيادة</span><input defaultValue="عيادات ابتسامة الرياض" /></label>
        <label className="field"><span>الدولة</span><select defaultValue="sa"><option value="sa">السعودية</option><option>الإمارات</option><option>الكويت</option><option>قطر</option><option>البحرين</option><option>عُمان</option></select></label>
        <label className="field"><span>المدينة</span><input defaultValue="الرياض" /></label>
        <label className="field"><span>عدد الفروع</span><input type="number" defaultValue="2" /></label>
        <label className="field"><span>عدد موظفي الاستقبال / منسقي المرضى</span><input type="number" defaultValue="4" /></label>
      </div>
    </div>
  );
}

function ServicesStep({ services, add, update, remove }) {
  return (
    <div className="onboarding-content">
      <h1>ما أهم الخدمات التي تقدمها؟</h1>
      <p>يساعد متوسط قيمة الخدمة Cencey على تقدير الإيرادات المعرضة للخسارة.</p>
      <div className="service-editor">
        {services.map((service, index) => (
          <div className="service-row" key={`${service.name}-${index}`}>
            <input value={service.name} onChange={(event) => update(index, 'name', event.target.value)} aria-label="اسم الخدمة" />
            <div><input type="number" value={service.value} onChange={(event) => update(index, 'value', event.target.value)} /><span>ر.س</span></div>
            <button onClick={() => remove(index)} aria-label="حذف"><SafeIcon icon={FiTrash2} /></button>
          </div>
        ))}
      </div>
      <button className="add-button" onClick={add}><SafeIcon icon={FiPlus} /> إضافة خدمة</button>
    </div>
  );
}

function DataStep({ file, setFile }) {
  const downloadSample = () => {
    const csv = 'lead_date,lead_id,service,source,estimated_value,status,loss_reason,last_contact,followups,coordinator,notes';
    const link = document.createElement('a');
    link.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
    link.download = 'cencey-sample.csv';
    link.click();
  };

  return (
    <div className="onboarding-content data-step">
      <h1>أضف بيانات العملاء المحتملين</h1>
      <p>يمكنك تجربة Cencey الآن باستخدام بيانات تجريبية قبل رفع بيانات عيادتك.</p>
      <div className="data-options">
        <label className={`data-option ${file ? 'selected' : ''}`}>
          <SafeIcon icon={file ? FiCheckCircle : FiUploadCloud} />
          <strong>{file || 'رفع ملف CSV / Excel'}</strong>
          <small>اسحب الملف هنا أو اضغط للاختيار</small>
          <input type="file" accept=".csv,.xlsx,.xls" onChange={(event) => setFile(event.target.files[0]?.name || '')} />
        </label>
        <button className="data-option" onClick={() => setFile('بيانات Cencey التجريبية')}>
          <SafeIcon icon={FiDatabase} />
          <strong>استخدام بيانات تجريبية</strong>
          <small>250 عميلًا محتملًا ببيانات واقعية</small>
        </button>
      </div>
      <button className="download-link" onClick={downloadSample}><SafeIcon icon={FiDownload} /> تحميل نموذج الملف</button>
      <div className="privacy-notice">
        <SafeIcon icon={FiShield} />
        <div><strong>الخصوصية مهمة</strong><p>Cencey مخصص لتحليل بيانات المبيعات والتحويل. لا ترفع السجلات الطبية أو التشخيصات أو التاريخ الطبي أو أي معلومات صحية حساسة.</p></div>
      </div>
    </div>
  );
}

export function Analysis({ navigate }) {
  const messages = ['نراجع رحلة العملاء...', 'نبحث عن نقاط تسرب الإيرادات...', 'نحلل أسباب خسارة الفرص...', 'نبحث عن فرص قابلة للاستعادة...', 'نجهز توصياتك...'];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const messageTimer = setInterval(() => setIndex((value) => Math.min(value + 1, messages.length - 1)), 650);
    const navigationTimer = setTimeout(() => navigate('/dashboard'), 3600);
    return () => {
      clearInterval(messageTimer);
      clearTimeout(navigationTimer);
    };
  }, [navigate]);

  return (
    <main className="analysis-page">
      <Brand />
      <div className="analysis-orbit"><span /><SafeIcon icon={FiDatabase} /></div>
      <h1>نحلل بياناتك الآن</h1>
      <p>{messages[index]}</p>
      <div className="analysis-progress"><span style={{ width: `${(index + 1) * 20}%` }} /></div>
      <small>عادةً يستغرق هذا أقل من دقيقة</small>
    </main>
  );
}